import { render, staticRenderFns } from "./LeagueTeams.vue?vue&type=template&id=027a1329&scoped=true&"
import script from "./LeagueTeams.vue?vue&type=script&lang=js&"
export * from "./LeagueTeams.vue?vue&type=script&lang=js&"
import style0 from "./LeagueTeams.vue?vue&type=style&index=0&id=027a1329&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a1329",
  null
  
)

export default component.exports